<style>
    .table-dashboard thead tr td {
        background: #1f2248;
        color: #fff;
    }
    .new-pemungut{
        border-bottom: 1px solid #000000 !important;
    }
    </style>
    <template>
        <zen-one
            :showuserinfo="false"
            title="Sistem Hasil Bersepadu Kedah (iHasil)"
            :crumbs="crumbs"
        >
            <z-page title=" Laporan Terimaan Kod Akaun Mengikut Penyata Pemungut">
                <w-form ref="dform" @validate="search">
                    <w-flex class="mt3">
                        <div class="xs6 mr3">
                            <w-input
                                v-model="cari.tarikh_dari"
                                required
                                label="Dari"
                                type="date"
                            />
                            <z-lookup
                                label="Jabatan"
                                :url="service_kutipan + 'lookup/jabatan_user'"
                                :sort="false"
                                :cache="false"
                                v-model="cari.jabatan_id"
                            />
                        </div>
                        <div class="xs6 mr3">
                            <w-input
                                v-model="cari.tarikh_hingga"
                                required
                                label="Hingga"
                                type="date"
                            />
                            <z-lookup 
                                label="Kod Akaun"
                                :url='service_kutipan+"lookup/akaun_akhir2"' 
                                :sort="false" 
                                :cache="false" 
                                v-model="cari.akaun_id" 
                            />
                        </div>
                        <div class="xs6 mr3">
                            <z-lookup
                                label="Jenis Kaunter"
                                :url="service_laporan + 'lookup/lkp_kaunter_baharu'"
                                :sort="false"
                                :cache="false"
                                v-model="cari.lkp_kaunter_id"
                            />
                        </div>
                    </w-flex>
                </w-form>
    
                <w-flex class="mt1 mb3" justify-end>
                    <div class="mt2 text-right">
                        <w-button
                            class="ml1"
                            v-on:click="reset()"
                            bg-color="warning"
                        >
                            <w-icon>fal fa-redo-alt</w-icon>&nbsp;Reset
                        </w-button>
                        <w-button class="ml1" @click="$refs.dform.validate()">
                            <w-icon>fal fa-search</w-icon>&nbsp;Cari
                        </w-button>
                    </div>
                </w-flex>
                <loading v-model:active="isLoading"
                    :can-cancel="false"
                    :opacity="0.7"
                    :is-full-page="false"/>
                <w-flex justify-center align-center class="mt5">
                    <div class="w-card__content content-hardcode" style="overflow-x:auto;max-height: 500px;">
                        <table class="table-dashboard" width="100%">
                            <thead>
                                <tr>
                                    <td>Bil</td>
                                    <td>No. Penyata Pemungut</td>
                                    <td>Amaun Penyata Pemungut (RM)</td>
                                    <td>No. Resit</td>
                                    <td>Tarikh Bayar</td>
                                    <td>Keterangan</td>
                                    <td>Amaun Resit (RM)</td>
                                </tr>
                            </thead>
                            <tbody>
                                <template v-if="table.items.length > 0">
                                    <template v-for="(dt, index) in table.items">
                                        <tr>
                                            <td style="border-top: 1px solid #000000 !important;" colspan="6"><b>KOD AKAUN: {{ dt.keterangan }}</b></td>
                                            <td style="border-top: 1px solid #000000 !important;text-align:right;"><b>{{ dt.amaun }}</b></td>
                                        </tr>
                                        <tr v-for="(deet, idx) in dt.details">
                                            <template v-if="idx == 0 || dt.details[idx-1] && dt.details[idx-1].no_penyata_pemungut != deet.no_penyata_pemungut">
                                                <td style="border-top: 1px solid #000000 !important;">{{deet.bil}}</td>
                                                <td style="border-top: 1px solid #000000 !important;">{{deet.no_penyata_pemungut}}</td>
                                                <td style="border-top: 1px solid #000000 !important;text-align:right;">{{deet.amaun_pemungut}}</td>
                                                <td style="border-top: 1px solid #000000 !important;">{{deet.no_resit}}</td>
                                                <td style="border-top: 1px solid #000000 !important;">{{deet.tarikh_bayar}}</td>
                                                <td style="border-top: 1px solid #000000 !important;">{{deet.keterangan}}</td>
                                                <td style="border-top: 1px solid #000000 !important;text-align:right;">{{deet.amaun}}</td>
                                            </template>
                                            <template v-else>
                                                <td>{{deet.bil}}</td>
                                                <td></td>
                                                <td></td>
                                                <td>{{deet.no_resit}}</td>
                                                <td>{{deet.tarikh_bayar}}</td>
                                                <td>{{deet.keterangan}}</td>
                                                <td style="text-align:right;">{{deet.amaun}}</td>
                                            </template>
                                        </tr>
                                        <tr>
                                            <td style="border-top: 1px solid #000000 !important;text-align:right;" colspan="6"><b>JUMLAH (RM)</b></td>
                                            <td style="border-top: 1px solid #000000 !important;text-align:right;"><b>{{ dt.amaun }}</b></td>
                                        </tr>
                                    </template>
                                    <tr>
                                        <td style="border-top: 1px solid #000000 !important;text-align:right;" colspan="6"><b>JUMLAH KESELURUHAN (RM)</b></td>
                                        <td style="border-top: 1px solid #000000 !important;text-align:right;"><b>{{ table.jumlah_keseluruhan }}</b></td>
                                    </tr>
                                </template>
                                <template v-else>
                                    <tr>
                                        <td colspan="7" style="text-align: center">Tiada Rekod</td>
                                    </tr>
                                </template>
                            </tbody>
                        </table>
                    </div>
                </w-flex>
    
                <w-flex class="mt1 mb3" justify-center>
                    <div class="mt2 text-center">
                        <w-button bg-color="success" class="mr3" @click="cetak()">
                            <w-icon>fal fa-print</w-icon>&nbsp;Cetak
                        </w-button>
                    </div>
                </w-flex>
            </z-page>
        </zen-one>
    </template>
    
    <script>
    import { reactive } from "vue";
    import ZenOne from "@/Shared/ZenOne";
    import ZResource from "@/Modules/z-resource-service";
    import Loading from 'vue-loading-overlay';
    import 'vue-loading-overlay/dist/css/index.css';
    
    export default {
        extends: ZResource,
        components: {
            // ZenOne
            Loading
        },
        props: {
            items: [Array, Object],
            auth: [Array, Object],
        },
        data() {
            return {
                resourceurl: this.service_laporan + "kutipan/laporan/dummy",
                reload: true,
                status: [
                    {
                        value: 1,
                        label: "Aktif",
                    },
                    {
                        value: 2,
                        label: "Tidak Aktif",
                    },
                ],
                crumbs: [
                    { label: "iHasil", route: "/" },
                    { label: "Kutipan", route: "/kutipan/laporan/terimaan_kod_akaun"},
                    { label: "Laporan", route: "/kutipan/laporan/terimaan_kod_akaun"},
                    {
                        label: "Laporan Terimaan Kod Akaun Mengikut Penyata Pemungut",
                        route: "/kutipan/laporan/terimaan_kod_akaun",
                    },
                ],
                cari: { tarikh_dari: "", tarikh_hingga: "", jabatan_id: "", akaun_id: "", lkp_kaunter_id: "" },
                isLoading: false,
            };
        },
        methods: {
            search() {
                this.getQueryData();
                // this.$inertia.visit(
                //     window.route("kutipan.laporan.terimaan_kod_akaun") + 
                //         "?tarikh_dari=" + this.cari.tarikh_dari +
                //         "&tarikh_hingga=" + this.cari.tarikh_hingga+
                //         "&jabatan_id=" + this.cari.jabatan_id+
                //         "&akaun_id=" + this.cari.akaun_id+
                //         "&lkp_kaunter_id=" + this.cari.lkp_kaunter_id,
                //     { preserveScroll: true }
                // );
            },
    
            reset() {
                this.cari = { tarikh_dari: "", tarikh_hingga: "", jabatan_id: "", akaun_id: "", lkp_kaunter_id: "" };
                this.search();
            },
    
            cetak() {
                window.open(this.service_laporan+'kutipan/laporan/terimaan_kod_akaun/cetak?user_id='+this.auth.user.id+
                "&tarikh_dari=" + this.cari.tarikh_dari +
                "&tarikh_hingga=" + this.cari.tarikh_hingga+
                "&jabatan_id=" + this.cari.jabatan_id+
                "&akaun_id=" + this.cari.akaun_id+
                "&lkp_kaunter_id=" + this.cari.lkp_kaunter_id,'_blank');
            },
            async getQueryData() {
                this.isLoading = true;
                const resp = await axios.get(
                    this.service_laporan + "kutipan/laporan/terimaan_kod_akaun?user_id=" + this.auth.user.id +
                    "&tarikh_dari=" + this.cari.tarikh_dari +
                    "&tarikh_hingga=" + this.cari.tarikh_hingga+
                    "&jabatan_id=" + this.cari.jabatan_id+
                    "&akaun_id=" + this.cari.akaun_id+
                    "&lkp_kaunter_id=" + this.cari.lkp_kaunter_id,
                );
                this.table = resp.data.data;
                // this.table.meta = resp.data.meta;
                this.isLoading = false;
            },
        },
        watch: {},
        mounted() {
            // console.log(this.datas);
            this.dialog.width = 900;
            this.cari = location.search
                .slice(1)
                .split("&")
                .map((p) => p.split("="))
                .reduce((obj, [key, value]) => ({ ...obj, [key]: value }), {});
            if (this.cari.tarikh_dari == "undefined") {
                this.cari.tarikh_dari = "";
            }
            if (this.cari.tarikh_hingga == "undefined") {
                this.cari.tarikh_hingga = "";
            }
            if (this.cari.jabatan_id == "undefined") {
                this.cari.jabatan_id = "";
            }
            if (this.cari.akaun_id == "undefined") {
                this.cari.akaun_id = "";
            }
            // console.log(this.auth.user.id);
        },
    };
    </script>
    <style>
    .w-select__menu {
        z-index: 999999;
    }
    </style>
    